// extracted by mini-css-extract-plugin
export default {"advertWrapper":"_9r54Cpq8","advert":"TtiiDXox","placeholder":"AdUnit_placeholder__9+QH63+x","background":"AdUnit_background__X4YZAA5n","content":"AdUnit_content__25pVcAXx"};